/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_ADDRESS } from "../graphql/updateAddress.query";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { filter } from "lodash";
import toast from "react-hot-toast";
import { ADD_TO_CART } from "../graphql/addToCart.mutation";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IAddToCartMethods extends IPluginMethodMap {
  AddToCart(args: any): Promise<any>;
}

export class AddToCartService implements IAgentPlugin {
  readonly methods: IAddToCartMethods;

  constructor() {
    this.methods = {
      AddToCart: this.AddToCart.bind(this),
    };
  }

  async AddToCart(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      console.log("args12345", args);
      if (client) {
        let variables: any = {
          data: {
            presentation: args?.presentationID,
            section: args?.sectionID,
            items: args?.items,
            referal: args?.refId,
          },
        };
        if (args?.address) {
          variables.data["address"] = args?.address;
        }
        if (args?.delivery) {
          variables.data["delivery"] = { isOpted: args?.delivery?.isOpted };
        } else {
          variables.data["delivery"] = { isOpted: false };
        }
        if (args?.availableTime) {
          variables.data["availableTime"] = args?.availableTime;
        }
        const res = await client.mutate({
          mutation: ADD_TO_CART,
          variables: variables,
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          toast.success("Added to Cart!");
          return true;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        toast.error(
          _display_message?.extensions?.display_message ??
            "Something went wrong"
        );
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
